/**
 * Members-area slice of the English catalog.
 *
 * en.ts sits against the 500-line fileSize ceiling and is the repo's recorded
 * merge hotspot — every parallel branch appends to the same tail. The revoke
 * keys were the seven lines that finally pushed it over (501L, ratchet red),
 * which is exactly the failure this carve-out pattern exists to prevent, so
 * the whole `members.*` vocabulary moves here rather than just the overflow.
 *
 * Spread back into `en` in en.ts, so `t()` and MessageKey are unchanged. Add
 * new members keys HERE, not in en.ts.
 */
import { enBrand } from './enBrand';

export const enMembers = {
  // Brand DNA (V38) rides on this slice — en.ts has no line left to import it.
  ...enBrand,
  // ── Members-area manual grant (customer surface) ──────────────────────
  'members.grant.title': 'Members area',
  'members.grant.sub': 'Send a magic link to the members lessons — automatic on payment, manual here.',
  'members.grant.cta': 'Grant access',
  'members.grant.granting': 'Granting…',
  'members.grant.done': 'Member link created and copied — send it over WhatsApp or email.',
  'members.grant.failed': 'Could not grant member access.',
  'members.grant.noUrl': 'No link returned.',
  'members.grant.linkLabel': 'Link (copied):',

  // ── Revoke. The counterpart /grant shipped without: access could be given
  //    and never taken back, because nothing wrote MemberAccess.revokedAt. ──
  'members.revoke.cta': 'Revoke access',
  'members.revoke.revoking': 'Revoking…',
  'members.revoke.done': 'Member access revoked — their link no longer works.',
  'members.revoke.none': 'This customer had no active member access.',
  'members.revoke.failed': 'Could not revoke member access.',
  'members.revoke.confirm':
    'Revoke this customer\'s members-area access? Their magic link will stop working immediately.',
} as const;
